import { ReportProperties } from './report-properties';
import { ElementType, Location } from './element-type';
import { ReportPreviewMetadata } from '../_services/report-template-design.service';
import { LangUpdateService } from '../_services/lang-update.service';
import { TranslateService } from '@ngx-translate/core';

export class ValidationErrorDetails {
  public type: string;
  public uuid: string;
  public pageIndex: number;
  public location: string;
  public validationErrorMessage: ValidationErrorMessage[] = [];

  constructor(
    property: ReportElement,
    name: string,
    error: string,
    protected translate: TranslateService,
    protected langService: LangUpdateService) {
    this.uuid = property.getId();
    this.pageIndex = property.getPageIndex();
    this.location = property.getLocation();
    this.type = property.getInputType();
    this.validationErrorMessage[0] = new ValidationErrorMessage(name, error);
  }
}

export class ValidationErrorMessage {
  public name: string;
  public errorMessage: string;

  constructor(name: string, error: string) {
    this.name = name;
    this.errorMessage = error;
  }
}

export abstract class ReportElement extends ReportProperties {
  isSelected: boolean;
  isSelectable: boolean;

  private index: number;
  private location: Location;
  private pageId: string;
  private pageIndex: number;

  constructor(type: ElementType, index: number, isExisting: boolean,
    protected translate: TranslateService,
    protected langService: LangUpdateService,
    id?: string
  ) {
    super(type, translate, langService, id);
    this.index = index;
    this.isSelected = false;
    this.isSelectable = true;
    this.setExistState(isExisting);
    this.setSaveState(isExisting); // 既存JSON定義をインスタンス化した直後なら、isExistingが示す状態と同じはず。
  }

  public abstract setDrawData(metadata: ReportPreviewMetadata);
  public abstract setDropData(metadata: ReportPreviewMetadata);
  public abstract setResizeData(metadata: ReportPreviewMetadata);
  public abstract getLeftPx(): number;
  public abstract getTopPx(): number;
  public abstract getWidthPx(): number;
  public abstract getHeightPx(): number;

  public setLocation(location: Location, pageId?: string, pageIndex?: number) {
    this.location = location;
    this.pageId = pageId;
    this.pageIndex = pageIndex;
  }

  public getIndex(): number {
    return this.index;
  }
  public getPageIndex(): number {
    return this.pageIndex;
  }
  public getInputType(): string {
    return this.type;
  }
  public setIndex(value: number) {
    this.index = value;
  }

  public getPageId(): string {
    return this.pageId;
  }

  public getLocation(): Location {
    return this.location;
  }

  public getElementType(): ElementType {
    return ElementType.cast(this.getType());
  }

  public getTitle(): string {
    const title = new Array<string>();
    title.push(this.translate.instant('objects.' + this.type));

    switch (this.type) {
      case 'Page':
        title.push((this.index + 1).toString());
        break;
      default:
        title.push((this.index + 1).toString());
        title.push('(');
        switch (this.location) {
          case 'Header':
          case 'Footer':
            title.push(this.translate.instant('objects.' + this.location));
            break;
          case 'Body':
            title.push(this.translate.instant('objects.Page') + '.' + (this.pageIndex + 1));
            title.push(this.translate.instant('objects.' + this.location));
            break;
        }
        title.push(')');
        break;
    }

    return title.join(' ').trim();
  }
}
